import React from 'react';
import LinkableTitle from '../../components/linkableTitle';
import CopyableSnippet from '../../components/utils/CopyableSnippet';

const Flex = () => (
  <React.Fragment>
    <div className="page-header">
      <p>Core</p>
      <h1>Flex</h1>
    </div>
    <div className="page-content">
      <div>
        <div className="component-example__sub-example">
          <p>
            <CopyableSnippet code="l-flex" />
          </p>
          <p className="component-example__grey-bg padding-xs l-flex">
            <div className="margin-xs padding-lg bg-white">item</div>
            <div className="margin-xs padding-lg bg-white">item</div>
            <div className="margin-xs padding-lg bg-white">item</div>
          </p>
        </div>
        <div className="component-example__sub-example">
          <p>
            <CopyableSnippet code="l-flex-spaced" />
          </p>
          <p className="component-example__grey-bg padding-xs l-flex-spaced">
            <div className="margin-xs padding-lg bg-white">item</div>
            <div className="margin-xs padding-lg bg-white">item</div>
            <div className="margin-xs padding-lg bg-white">item</div>
          </p>
        </div>
        <div className="component-example__sub-example">
          <p>
            <CopyableSnippet code="l-flex-hcenter" />
          </p>
          <p className="component-example__grey-bg padding-xs l-flex-hcenter">
            <div className="margin-xs padding-lg bg-white">item</div>
            <div className="margin-xs padding-lg bg-white">item</div>
            <div className="margin-xs padding-lg bg-white">item</div>
          </p>
        </div>
        <div className="component-example__sub-example">
          <p>
            <CopyableSnippet code="l-flex-vcenter" />
          </p>
          <p className="component-example__grey-bg padding-xs l-flex-vcenter" style={{ height: 300 }}>
            <div className="margin-xs padding-lg bg-white">item</div>
            <div className="margin-xs padding-lg bg-white">item</div>
            <div className="margin-xs padding-lg bg-white">item</div>
          </p>
        </div>
        <div className="component-example__sub-example">
          <p>
            <CopyableSnippet code="l-flex-hcenter.l-flex-vcenter" />
          </p>
          <p
            className="component-example__grey-bg padding-xs l-flex-hcenter l-flex-vcenter"
            style={{ height: 300 }}
          >
            <div className="margin-xs padding-lg bg-white">item</div>
            <div className="margin-xs padding-lg bg-white">item</div>
            <div className="margin-xs padding-lg bg-white">item</div>
          </p>
        </div>

        <LinkableTitle name="responsive-flex" title="Responsive flex" />
        <p>
          For responsive flex use
          <CopyableSnippet code="l-flex-(screen)" />
          classes
        </p>
        <p>
          The (screen) values are
          <CopyableSnippet code="screen-xs" />
          <CopyableSnippet code="screen-sm" />
          <CopyableSnippet code="screen-md" />
          <CopyableSnippet code="screen-ml" />
          <CopyableSnippet code="screen-lg" />
        </p>
        <div className="component-example__sub-example margin-top-lg">
          <p>
            <CopyableSnippet code="l-flex-screen-sm" />
          </p>
          <p className="component-example__grey-bg padding-xs l-flex-screen-sm">
            <div className="margin-xs padding-lg bg-white">item</div>
            <div className="margin-xs padding-lg bg-white">item</div>
            <div className="margin-xs padding-lg bg-white">item</div>
          </p>
        </div>
        <div className="component-example__sub-example">
          <p>
            <CopyableSnippet code="l-flex-hcenter-screen-md" />
          </p>
          <p className="component-example__grey-bg padding-xs l-flex-hcenter-screen-md">
            <div className="margin-xs padding-lg bg-white">item</div>
            <div className="margin-xs padding-lg bg-white">item</div>
            <div className="margin-xs padding-lg bg-white">item</div>
          </p>
        </div>
      </div>
    </div>
  </React.Fragment>
);

export default Flex;